import BaseApi from './BaseApi'

class InvoicesApi extends BaseApi {
  downloadLinkForInvoice (invoiceId, fileName) {
    const url = `/invoices/${invoiceId}`
    const method = 'get'
    this.downloadAsFile(
      { url, method },
      'application/pdf',
      fileName
    )
  }
}

export default new InvoicesApi()
